import { UserRole } from './common';
import { Doctor, Patient, User } from './users';

// Union Type: A user can be a generic User, a Patient, or a Doctor
export type UserProfile = User | Patient | Doctor;

// 2. Type Guards (Helpers to check who is who)
export const isPatient = (user: UserProfile | null): user is Patient => {
  return user?.role === UserRole.PATIENT;
};

export const isDoctor = (user: UserProfile | null): user is Doctor => {
  return user?.role === UserRole.DOCTOR;
};

export const isAdmin = (user: UserProfile | null): user is User => {
  return user?.role === UserRole.ADMIN;
};